export default __webpack_public_path__ + "static/media/hånd_over_mobil.e26dc56b.svg";